mutation DeleteTugOfWar($tugId: ID!) {
  result: StreamToolsDeleteTugOfWar(tugId: $tugId) {
    id
    deleted
  }
}
